import { get } from "lodash";
import { DEFAULT_LINKED_RESOURCES, QURE_AIRA_CREATOR_EMAIL } from "../constants";
import { t } from "i18next";
var DEFAULT_LABEL_ARRAY = [{
  id: 0,
  name: t("label.task"),
  color: ""
}];
export var transformPatientReminders = function transformPatientReminders(data) {
  if (!Array.isArray(data)) return [];
  return data.map(function (reminder) {
    var transformedReminder = transformReminder(reminder);
    if (isReminder(transformedReminder)) return transformedReminder;
    return [];
  });
};
var transformReminder = function transformReminder(reminder) {
  var creatorEmail = get(reminder, ["created_by_info", "email"], "");
  return {
    id: get(reminder, "id", -1),
    patient_id: get(reminder, "patient_id", -1),
    title: get(reminder, "title", ""),
    context: get(reminder, "context", ""),
    remind_after: get(reminder, "remind_after", ""),
    resolved: get(reminder, "resolved", false),
    created_by: get(reminder, "created_by", ""),
    owned_by: get(reminder, ["owned_by_info", "id"], null),
    created_by_id: get(reminder, "created_by_id", -1),
    created_at: get(reminder, "created_at", ""),
    created_by_info: get(reminder, "created_by_info", null),
    owned_by_info: get(reminder, "owned_by_info", null),
    labels: get(reminder, "labels", DEFAULT_LABEL_ARRAY),
    linked_resources: get(reminder, "linked_resources", DEFAULT_LINKED_RESOURCES),
    isAira: creatorEmail === QURE_AIRA_CREATOR_EMAIL
  };
};
var isReminder = function isReminder(item) {
  if (item.id === -1 || item.patient_id === -1 || item.title === "" || item.remind_after === "" || item.created_by === "") return false;
  return true;
};